import { create } from "zustand";
import { DialogActions, DialogConfig, DialogState } from "./types";

export const useDialogStore = create<DialogState & DialogActions>(set => ({
  dialogs: {},

  openDialog: (config: DialogConfig) =>
    set(state => ({
      dialogs: {
        ...state.dialogs,
        [config.key]: config,
      },
    })),

  closeDialog: (key: string) =>
    set(state => ({
      dialogs: {
        ...state.dialogs,
        [key]: state.dialogs[key]
          ? { ...state.dialogs[key], closing: true }
          : state.dialogs[key],
      },
    })),

  removeDialog: (key: string) =>
    set(state => {
      const { [key]: _, ...rest } = state.dialogs;
      return { dialogs: rest };
    }),

  closeAllDialogs: () =>
    set(state => {
      const closingDialogs = Object.keys(state.dialogs).reduce(
        (acc, key) => ({
          ...acc,
          [key]: { ...state.dialogs[key], closing: true },
        }),
        {},
      );
      return { dialogs: closingDialogs };
    }),

  isDialogOpen: (key: string): boolean => {
    const state = useDialogStore.getState();
    return !!state.dialogs[key];
  },

  setDialogConfirming: (key: string, confirming: boolean) =>
    set(state => ({
      dialogs: {
        ...state.dialogs,
        [key]: state.dialogs[key]
          ? { ...state.dialogs[key], confirming }
          : state.dialogs[key],
      },
    })),
}));
